import { useState,useEffect } from "react";
import { useParams,useLocation } from "react-router-dom";
import BASE_URL from "../../BaseUrl";
import axios from "axios";
import { color } from "framer-motion";
export default function ExamResults({setActive,setMobileActive,isAdmin}){
  const [results, setResults] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const location = useLocation();
  const examName = location.state?.examName || "الاختبار";
  const {examId} = useParams();
  useEffect(()=>{
    setActive("المواد الدراسية");
    setMobileActive("courses mobile");
    axios.get(`${BASE_URL}/${isAdmin?"teacher":"assistant"}/exam-results?examId=${examId}`,{withCredentials:true})
    .then((response)=>{
      console.log(response.data);
      setResults(response.data|| []);
      setLoaded(true);
    }).catch((error)=>{
      console.log(error);
      alert("حدث خطأ أثناء جلب النتائج");
    })
  },[])
  return(
    <div className="page-container space-y-4">
      <h2>نتائج الاختبار</h2>
      <h2 >{examName}</h2>
      {!loaded ? <p>جارٍ تحميل النتائج...</p> : 
      <table className="results-table">
        <thead>
          <tr>
            <th> تاريخ التسليم</th>
            <th>الدرجة</th>
            <th>اسم الطالب</th>
            <th>الترتيب</th>
          </tr>
        </thead>
        <tbody>
          {(results.length === 0)? <tr><td colSpan="4" style={{textAlign:"center"}}>لا توجد نتائج بعد</td></tr> :
          (results.map((result,index)=>(
            <tr style={{backgroundColor:`${result.studentGrade > result.finalGrade/2 ? "#78ED6D" : "#FF3F2E"}`}}>
              <td>{result.date.toString().split("T")[0]}</td>
              <td>{result.studentGrade}/{result.finalGrade}</td>
              <td>{result.studentName}</td>
              <td>{index+1}</td>
            </tr>
          )))}
          </tbody>
      </table>}

    </div>
  )
}